export const RIGHT_NAV_ALIGN_ITEMS = 'center';
